import { Box, Typography } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

export interface DefaultFieldsProps {
  text?: string;
}
export const DefaultFields: PimoReactComponent<DefaultFieldsProps> = () => {
  return (
    <Box sx={{ display: "flex", gap: 10, width: "100%" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: 500, minWidth: 280 }}></Typography>
        </Box>
      </Box>
    </Box>
  );
};
